// Tiny env-aware logger.
// Production build strips all output; dev still logs for debugging.
// Errors always surface (you can swap the `error` branch for Sentry later).
const isProd = process.env.NODE_ENV === "production";

export const log = {
  debug: isProd ? () => {} : (...args) => console.debug(...args),
  warn:  isProd ? () => {} : (...args) => console.warn(...args),
  error: (...args) => { if (!isProd) console.error(...args); /* else: forward to monitoring */ },
};
